export const password = () => ({
  disabled: false,
  error: false,
  showPassword: false,
  showRegexError: false,
  value: '',
  valid: {
    emptySpace: true,
    minLength: false,
    minChar: false,
    minNumber: false,
    minSpecialChar: false,
  },
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
    this.$refs.input.type = this.showPassword ? 'text' : 'password';
    this.$refs.input.focus();
  },
  onInvalid(event) {
    event.preventDefault();
    this.error = true;
  },
  validate() {
    if (!this.value.includes(' ')) {
      this.valid.emptySpace = true;
    } else {
      this.valid.emptySpace = false;
    }
    if (this.value.length >= 8) {
      this.valid.minLength = true;
    } else {
      this.valid.minLength = false;
    }
    if (/^(?=.*[a-zA-Z]).+$/.test(this.value)) {
      this.valid.minChar = true;
    } else {
      this.valid.minChar = false;
    }
    if (/^(?=.*[0-9]).+$/.test(this.value)) {
      this.valid.minNumber = true;
    } else {
      this.valid.minNumber = false;
    }
    if (/^(?=.*[~!@#$%^&*()_+=]).+$/.test(this.value)) {
      this.valid.minSpecialChar = true;
    } else {
      this.valid.minSpecialChar = false;
    }
    if (
      !this.valid.emptySpace ||
      !this.valid.minLength ||
      !this.valid.minChar ||
      !this.valid.minNumber ||
      !this.valid.minSpecialChar
    ) {
      this.error = true;
      this.$refs.input.setCustomValidity('Kriterien beachten.');
    } else {
      this.error = false;
      this.$refs.input.setCustomValidity('');
    }
  },
});
